import { memo } from "react";

const Crown = ({ color, pop }) => (
  <g className={pop ? "dames-crown" : ""} data-testid="dames-crown">
    <path d="M-12 4 L-14 -8 L-6 -2 L0 -12 L6 -2 L14 -8 L12 4 Z" fill={color} stroke="#7a5200" strokeWidth="1.2" strokeLinejoin="round" />
    <rect x="-12" y="4" width="24" height="4" rx="1.5" fill={color} stroke="#7a5200" strokeWidth="1" />
  </g>
);

// Round piece with light relief: radial gradient, engraved rings, soft top highlight, shadow under it.
export const DamesPiece = memo(({ id, piece, x, y, lifted, faded, fading, hop, theme, noTransition, pop }) => {
  const white = piece.toLowerCase() === "w";
  const g = white ? "w" : "b";
  const ring = white ? "rgba(120,90,50,0.35)" : "rgba(255,255,255,0.12)";
  const s = lifted ? 1.06 : 1;
  return (
    <g style={{ transform: `translate(${x}px, ${y}px)`, transition: noTransition ? "none" : "transform 250ms cubic-bezier(.3,.7,.3,1)" }} data-testid={id}>
      <g key={hop} className={hop ? "dames-hop" : ""}>
        <g style={{ transform: `scale(${fading ? 0.2 : s})`, opacity: fading ? 0 : faded ? 0.4 : 1, transition: "transform 280ms ease, opacity 280ms ease" }}>
          <ellipse cx="2" cy={lifted ? 9 : 5} rx="24" ry="22" fill="#000" opacity={lifted ? 0.45 : 0.32} filter="url(#dm-soft)" />
          <circle r="25" fill={`url(#dm-${g})`} stroke={theme[g === "w" ? "white" : "black"][2]} strokeWidth="1.5" />
          <circle r="19" fill="none" stroke={ring} strokeWidth="1.4" />
          <circle r="12" fill="none" stroke={ring} strokeWidth="1.2" />
          <ellipse cx="-6" cy="-11" rx="11" ry="5.5" fill="#fff" opacity={white ? 0.45 : 0.18} />
          {piece === piece.toUpperCase() && <Crown color="#E8B931" pop={pop} />}
        </g>
      </g>
    </g>
  );
});
DamesPiece.displayName = "DamesPiece";

export const BoardDefs = ({ theme }) => (
  <defs>
    {["white", "black"].map((k) => (
      <radialGradient key={k} id={`dm-${k[0]}`} cx="38%" cy="32%" r="75%">
        <stop offset="0%" stopColor={theme[k][0]} />
        <stop offset="55%" stopColor={theme[k][1]} />
        <stop offset="100%" stopColor={theme[k][2]} />
      </radialGradient>
    ))}
    <filter id="dm-soft" x="-50%" y="-50%" width="200%" height="200%"><feGaussianBlur stdDeviation="2.5" /></filter>
    <filter id="dm-grain" x="0" y="0" width="100%" height="100%">
      <feTurbulence type="fractalNoise" baseFrequency="0.012 0.22" numOctaves="3" seed="7" />
      <feColorMatrix values="0 0 0 0 0.12  0 0 0 0 0.07  0 0 0 0 0.02  0 0 0 -1.1 0.9" />
    </filter>
    <filter id="dm-frame-shadow" x="-10%" y="-10%" width="120%" height="125%"><feDropShadow dx="0" dy="10" stdDeviation="12" floodOpacity="0.55" /></filter>
  </defs>
);
